<header class="app-header d-flex align-items-center">
  <button
    type="button"
    class="header-icon me-2"
    [attr.aria-expanded]="globalAssist.isOpen()"
    aria-controls="global-assist-panel"
    aria-label="Open assistant"
    (click)="globalAssist.toggle()"
  >
    <i class="bi bi-chat-square-text"></i>
  </button>
  <div class="flex-grow-1">
    <app-breadcrumbs></app-breadcrumbs>
  </div>
  @if (currentProjectName(); as name) {
    <span class="header-project-name me-4" [attr.title]="name">
      {{ name }}
    </span>
  }
  <a
    class="header-icon position-relative me-4"
    [routerLink]="['/notifications']"
    aria-label="Notifications"
    >
    <i class="bi bi-bell"></i>
    @if (notificationCount() > 0) {
      <span
        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
        >
        {{ notificationCount() }}
      </span>
    }
  </a>
  <app-project-selector></app-project-selector>
</header>
